/* ============================================================
   NIGHTLEGS — THEME.JS
   Global init, smooth scrolling, misc helpers
   ============================================================ */

(function() {
  'use strict';

  // Smooth scroll for anchor links
  document.addEventListener('click', function(e) {
    var link = e.target.closest('a[href^="#"]');
    if (!link) return;

    var hash = link.getAttribute('href');
    if (hash === '#') return;

    var target = document.querySelector(hash);
    if (!target) return;

    e.preventDefault();

    var headerHeight = parseInt(
      getComputedStyle(document.documentElement).getPropertyValue('--header-height-sticky') || '48',
      10
    );

    var offset = target.getBoundingClientRect().top + window.scrollY - headerHeight - 16;
    window.scrollTo({ top: offset, behavior: 'smooth' });
  });

  // Add bottom padding so sticky ATC doesn't cover content on mobile
  function updateStickyPadding() {
    var stickyBar = document.getElementById('sticky-atc');
    if (!stickyBar) return;
    var isVisible = stickyBar.classList.contains('is-visible');
    document.body.style.paddingBottom = isVisible ? (stickyBar.offsetHeight + 'px') : '';
  }

  var stickyBar = document.getElementById('sticky-atc');
  if (stickyBar) {
    var observer = new MutationObserver(updateStickyPadding);
    observer.observe(stickyBar, { attributes: true, attributeFilter: ['class'] });
  }

  // Lazy-load images with IntersectionObserver (fallback for browsers without native lazy)
  if ('IntersectionObserver' in window) {
    var lazyImgs = document.querySelectorAll('img[loading="lazy"]');
    if (lazyImgs.length && !('loading' in HTMLImageElement.prototype)) {
      var imgObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            var img = entry.target;
            if (img.dataset.src) img.src = img.dataset.src;
            imgObserver.unobserve(img);
          }
        });
      });
      lazyImgs.forEach(function(img) { imgObserver.observe(img); });
    }
  }

  // Advertorial progress bar
  var progressBar = document.getElementById('advertorial-progress');
  if (progressBar) {
    var articleEl = document.getElementById('advertorial-article');
    var advertorialFired = false;

    window.addEventListener('scroll', function() {
      if (!articleEl) return;
      var rect     = articleEl.getBoundingClientRect();
      var total    = articleEl.offsetHeight;
      var scrolled = -rect.top;
      var pct      = Math.max(0, Math.min(100, (scrolled / total) * 100));

      progressBar.style.width = pct + '%';
      progressBar.setAttribute('aria-valuenow', Math.round(pct));

      // Fire Meta pixel at 75% scroll depth
      if (pct >= 75 && !advertorialFired) {
        advertorialFired = true;
        if (typeof fbq !== 'undefined') {
          fbq('trackCustom', 'AdvertorialLead', { scroll_depth: 75 });
        }
      }
    }, { passive: true });
  }

})();

// ============================================================
// HEADER — sticky + mobile menu + cart toggle
// ============================================================
(function() {
  var header      = document.getElementById('site-header');
  var overlay     = document.getElementById('site-overlay');
  var mobileMenu  = document.getElementById('mobile-nav');
  var menuToggle  = document.getElementById('mobile-menu-toggle');
  var menuClose   = document.getElementById('mobile-menu-close');
  var cartToggle  = document.getElementById('cart-toggle');

  // Hide the whole header group on scroll-down; reveal the navbar on scroll-up.
  if (header) {
    var lastY = window.scrollY;
    var ticking = false;
    var TOP_THRESHOLD = 50; // px — within this of the top, always show the full group
    var DELTA = 4;          // ignore sub-pixel jitter
    function updateHeader() {
      var y = window.scrollY;
      var body = document.body;
      if (y <= TOP_THRESHOLD) {
        // At/near the top: full announcement + header, nothing hidden
        body.classList.remove('nav-hidden', 'nav-pinned');
      } else if (y > lastY + DELTA) {
        // Scrolling down — hide everything
        body.classList.add('nav-hidden');
        body.classList.remove('nav-pinned');
      } else if (y < lastY - DELTA) {
        // Scrolling up — pop the navbar back
        body.classList.add('nav-pinned');
        body.classList.remove('nav-hidden');
      }
      lastY = y;
      ticking = false;
    }
    window.addEventListener('scroll', function() {
      if (!ticking) { window.requestAnimationFrame(updateHeader); ticking = true; }
    }, { passive: true });
  }

  // Mobile menu helpers
  function openMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.add('is-open');
    mobileMenu.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.classList.add('is-active');
    if (menuToggle) { menuToggle.setAttribute('aria-expanded', 'true'); menuToggle.classList.add('is-open'); }
    document.body.style.overflow = 'hidden';
  }
  function closeMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.remove('is-open');
    mobileMenu.setAttribute('aria-hidden', 'true');
    if (overlay) overlay.classList.remove('is-active');
    if (menuToggle) { menuToggle.setAttribute('aria-expanded', 'false'); menuToggle.classList.remove('is-open'); }
    document.body.style.overflow = '';
  }

  if (menuToggle) menuToggle.addEventListener('click', openMenu);
  if (menuClose)  menuClose.addEventListener('click', closeMenu);
  if (overlay)    overlay.addEventListener('click', closeMenu);
  document.addEventListener('keydown', function(e) { if (e.key === 'Escape') closeMenu(); });

  // Cart
  if (cartToggle) {
    cartToggle.addEventListener('click', function() {
      document.dispatchEvent(new CustomEvent('cart:open'));
    });
  }

  // Cart count update
  document.addEventListener('cart:updated', function(e) {
    var el = document.getElementById('cart-count');
    if (!el) return;
    var count = (e.detail && e.detail.item_count) || 0;
    el.textContent = count;
    el.classList.toggle('is-empty', count === 0);
  });
})();

// FAQ accordion
document.addEventListener('click', function(e) {
  var btn = e.target.closest('.faq__question');
  if (!btn) return;
  var isOpen = btn.classList.contains('is-open');
  var list = btn.closest('.faq__list');
  if (list) {
    list.querySelectorAll('.faq__question').forEach(function(b) {
      b.classList.remove('is-open'); b.setAttribute('aria-expanded','false');
      var a = document.getElementById(b.getAttribute('aria-controls'));
      if (a) a.classList.remove('is-open');
    });
  }
  if (!isOpen) {
    btn.classList.add('is-open'); btn.setAttribute('aria-expanded','true');
    var ans = document.getElementById(btn.getAttribute('aria-controls'));
    if (ans) ans.classList.add('is-open');
  }
});

// Results bar count-up animation
(function() {
  var section = document.getElementById('results-bar');
  if (!section) return;
  var done = false;
  function animate() {
    if (done) return; done = true;
    section.querySelectorAll('.result-item__number[data-target]').forEach(function(el) {
      var t = parseInt(el.dataset.target, 10), start = null;
      function step(ts) { if (!start) start=ts; var p=Math.min((ts-start)/1400,1), e=1-Math.pow(1-p,3); el.textContent=Math.round(e*t)+'%'; if(p<1)requestAnimationFrame(step); } requestAnimationFrame(step);
    });
    section.querySelectorAll('.result-item__fill[data-target]').forEach(function(el) { el.style.width=el.dataset.target+'%'; });
  }
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function(entries) { if(entries[0].isIntersecting) animate(); },{threshold:.3}).observe(section);
  } else { animate(); }
})();

// Product page accordions
document.addEventListener('click', function(e) {
  var btn = e.target.closest('.product-accordion__btn');
  if (!btn) return;
  var isOpen = btn.getAttribute('aria-expanded') === 'true';
  var content = document.getElementById(btn.getAttribute('aria-controls'));
  btn.setAttribute('aria-expanded', !isOpen);
  if (content) content.classList.toggle('is-open', !isOpen);
});


/* ============================================================
   LAZY AUTOPLAY — demo loop + review/before-after clips
   The big demo hero stays preload="none" (off the critical path).
   Review + before/after clips ship native autoplay muted loop +
   preload="metadata" so an in-view clip fires "no matter what"
   even before this JS runs. This observer stays the traffic cop:
   it plays clips entering the viewport and PAUSES ones that leave
   (incl. cards scrolled off a horizontal strip), so off-screen
   clips don't keep decoding.
   ============================================================ */
document.addEventListener('DOMContentLoaded', function() {
  // .nl-lazyvid = generic lazy-autoplay class (video reviews, before/after pairs)
  var vids = document.querySelectorAll('.demo-proof__video, .nl-lazyvid');
  if (!vids.length) return;

  function start(v) {
    if (!v.dataset.nlUnmuted) v.muted = true; // required for programmatic autoplay
    var p = v.play();
    if (p && p.catch) p.catch(function() {});
  }

  if (!('IntersectionObserver' in window)) {
    vids.forEach(function(v) { start(v); });
    return;
  }

  var obs = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) start(entry.target);
      else if (!entry.target.paused) entry.target.pause();
    });
  }, { rootMargin: '200px 0px', threshold: 0.1 });

  vids.forEach(function(v) { obs.observe(v); });
});

/* ============================================================
   VIDEO SOUND TOGGLE — .nl-vid-sound buttons sit on lazy videos.
   One video audible at a time; everything else stays muted.
   ============================================================ */
document.addEventListener('click', function(e) {
  var btn = e.target.closest('.nl-vid-sound');
  if (!btn) return;
  var frame = btn.parentElement;
  var video = frame ? frame.querySelector('video') : null;
  if (!video) return;

  var unmuting = video.muted;

  // Mute every other lazy video + reset its button
  document.querySelectorAll('.nl-lazyvid').forEach(function(v) {
    if (v === video) return;
    v.muted = true;
    delete v.dataset.nlUnmuted;
  });
  document.querySelectorAll('.nl-vid-sound').forEach(function(b) {
    if (b === btn) return;
    b.setAttribute('aria-pressed', 'false');
    var ic = b.querySelector('.material-symbols-rounded');
    if (ic) ic.textContent = 'volume_off';
  });

  video.muted = !unmuting;
  if (unmuting) { video.dataset.nlUnmuted = '1'; } else { delete video.dataset.nlUnmuted; }
  btn.setAttribute('aria-pressed', unmuting ? 'true' : 'false');
  var icon = btn.querySelector('.material-symbols-rounded');
  if (icon) icon.textContent = unmuting ? 'volume_up' : 'volume_off';
  if (unmuting && video.paused) { var p = video.play(); if (p && p.catch) p.catch(function() {}); }
});
